import { Table } from 'react-bootstrap';
import type { TopAgentRow } from '../../apps/apis/claudeCodeDashboard/types';
import { HELP_TEXT } from './agentTelemetryHelp';
import { HelpLabel } from './HelpTooltip';

interface Props {
  data: TopAgentRow[];
  countLabel?: 'Employees' | 'Sessions';
}

const TopAgentsTable = ({ data, countLabel = 'Employees' }: Props) => {
  if (data.length === 0) {
    return <div className="text-muted small">No agent invocations in the selected window.</div>;
  }
  return (
    <Table size="sm" hover responsive>
      <thead>
        <tr>
          <th>
            <HelpLabel description={HELP_TEXT.topAgents}>Agent</HelpLabel>
          </th>
          <th className="text-end">
            <HelpLabel description={HELP_TEXT.invocations}>Invocations</HelpLabel>
          </th>
          <th className="text-end">
            <HelpLabel description={countLabel === 'Sessions' ? HELP_TEXT.sessions : HELP_TEXT.employees}>
              {countLabel}
            </HelpLabel>
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => {
          const count = countLabel === 'Sessions' ? row.uniqueSessions : row.uniqueEmployees;
          return (
            <tr key={row.name}>
              <td className="text-monospace">{row.name}</td>
              <td className="text-end">{row.invocations.toLocaleString()}</td>
              <td className="text-end">{count?.toLocaleString() ?? '-'}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default TopAgentsTable;
